import React from "react";
import { Rating } from "@mui/material";
import { getDate } from "utils/utils";

type Props = {
  url?: string;
  date?: string;
  username?: string;
  rating?: number;
  content?: string;
};

const Review: React.FC<Props> = ({ url, date, username, rating, content }) => {
  return (
    <div className="flex sm:flex-col gap-6 p-3 border-solid border-[1px] border-[#bdbdbd] rounded-md shadow-md hover:shadow-none cursor-default">
      <img
        src={url}
        alt="logo"
        className="min-w-[54px] max-w-[54px] min-h-[54px] max-h-[54px] rounded-full bg-[#D8D8D8] border-solid border-[1px] border-[#979797]"
      />
      <div className="grid gap-[8px]">
        <Rating value={rating} readOnly />
        <span className="main-text">
          {username}, {getDate(date)}
        </span>
        <p>{content}</p>
      </div>
    </div>
  );
};

export default Review;
